
import { Link } from 'react-router-dom';

const areas = [
  { name: 'Watford', path: '/areas/watford', description: 'Painting & decorating across Watford Town Centre, Oxhey, Garston & more.' },
  { name: 'Rickmansworth', path: '/areas/rickmansworth', description: 'Quality finishes throughout Rickmansworth and surrounding villages.' },
  { name: 'Northwood', path: '/areas/northwood', description: 'Trusted decorators serving Northwood and nearby neighbourhoods.' },
  { name: 'Pinner', path: '/areas/pinner', description: 'Expert painters covering Pinner and the local area.' },
  { name: 'Bushey', path: '/areas/bushey', description: 'Professional painting services across Bushey and Bushey Heath.' },
  { name: 'Radlett', path: '/areas/radlett', description: 'Premium decorating services in Radlett and surrounding areas.' },
  { name: 'Chorleywood', path: '/areas/chorleywood', description: 'Skilled painters serving Chorleywood and nearby communities.' },
  { name: "Gerrard's Cross", path: '/areas/gerrards-cross', description: "High-quality decorating across Gerrard's Cross and the Chilterns." },
];

export default function ServiceAreas() {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-amber-600 text-sm font-medium tracking-wider uppercase mb-3">Where We Work</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Areas We Serve
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto leading-relaxed">
            We provide professional painting and decorating services across Hertfordshire and the surrounding areas.
            Whether you're in <strong>Watford</strong>, Rickmansworth, or anywhere in between — we've got you covered.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
          {areas.map((area) => (
            <Link
              key={area.path}
              to={area.path}
              className="group block p-6 bg-beige-50 border border-beige-200 rounded-lg hover:border-amber-400 hover:shadow-md transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 flex items-center justify-center bg-amber-100 rounded-full group-hover:bg-amber-200 transition-colors">
                  <i className="ri-map-pin-2-line text-amber-600 text-base"></i>
                </div>
                <h3 className="text-base font-semibold text-gray-800 group-hover:text-amber-600 transition-colors">
                  {area.name}
                </h3>
              </div>
              <p className="text-xs text-gray-500 leading-relaxed">{area.description}</p>
              <div className="mt-4 flex items-center gap-1 text-amber-600 text-xs font-medium">
                <span>View area</span>
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/areas"
            className="inline-flex items-center gap-2 px-6 py-3 border border-amber-500 text-amber-600 hover:bg-amber-500 hover:text-white font-medium rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-map-2-line"></i>
            View All Service Areas
          </Link>
        </div>
      </div>
    </section>
  );
}
